import Vue from 'vue';

Vue.directive('fillable', {
    inserted(el, binding, vnode) {
        let {
            val
        } = binding.value;
        val = val < 0 ? 0 : val > 100 ? 100 : val;
        let to_fill = (val / 100);
        let to_rotate, translate;
        let left_side = [],
            right_side = [];

        for (let i = 0; i <= 50; i++) {
            let step = 1.8;
            right_side.push(step * i)
            left_side.push((-1) * step * i);
        }

        to_rotate = val < 50 ? left_side[50 - Math.ceil(val)] : val == 50 ? 0 : right_side[Math.ceil(val) - 50];
        translate = val < 50 ? 0 : val == 50 ? 50 : 100;
        if (binding.modifiers.fill)
            el.style.transform = `rotate(${(to_fill)/2}turn)`;
        else if (binding.modifiers.cover)
            el.style.transform = `translateX(${-50}%)rotate(${to_rotate}deg)`;
    },
    unbind() {}
})